import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StudyFile } from 'src/app/models/Study/study-file.model';
import { MediaCategory } from 'src/app/models/media/media-category.model';
import { MediaGroup } from 'src/app/models/media/media-group.model';

@Component({
  selector: 'app-multiple-xrays',
  templateUrl: './multiple-xrays.component.html',
  styleUrls: ['./multiple-xrays.component.scss'],
})
export class MultipleXraysComponent {
  @Input() studyFiles: StudyFile[] = [];
  @Input() mediaGroups: MediaGroup[] = [];
  @Input() mediaCategories: MediaCategory[] = [];
  @Output() changeMediaCategory: EventEmitter<{
    studyFile: StudyFile;
    mediaCategoryId: number;
  }> = new EventEmitter<{ studyFile: StudyFile; mediaCategoryId: number }>();
  @Output() uploadAsAdditional: EventEmitter<{
    studyFile: StudyFile;
    isAdditional: boolean;
  }> = new EventEmitter<{ studyFile: StudyFile; isAdditional: boolean }>();
  @Output() deleteStudyFile: EventEmitter<number> = new EventEmitter<number>();

  @Output() useImage: EventEmitter<StudyFile[]> = new EventEmitter<
    StudyFile[]
  >();

  emitChangeMediaCategory(model: {
    studyFile: StudyFile;
    mediaCategoryId: number;
  }): void {
    this.changeMediaCategory.emit(model);
  }

  emitUploadAsAdditional(model: {
    studyFile: StudyFile;
    isAdditional: boolean;
  }): void {
    this.uploadAsAdditional.emit(model);
  }

  emitDeleteStudyFile(studyFileId: number): void {
    this.deleteStudyFile.emit(studyFileId);
  }

  emitUseImage(usingStudyFileId: number, studyFiles: StudyFile[]): void {
    this.useImage.emit(
      studyFiles.filter((sf) => sf.studyFileId !== usingStudyFileId)
    );
  }

  // trackBy: identifyCategory

  identifyStudyFile(index: number, item: StudyFile) {
    return item.studyFileId;
  }

  identifyGroup(index: number, item: MediaGroup) {
    return item.id;
  }

  identifyCategory(index: number, item: MediaCategory) {
    return item.id;
  }
}
